// Used by `ng serve --configuration=hetzner-staging` (see angular.json fileReplacements).
// Real Azure AD B2C login (same dev tenant/app registration as environment.staging.ts) against
// the ESA-API container running on this same Hetzner box (esaamlg-stg.akryldev.de). apiUrl is
// this deployment's own origin (NOT '/api' — every request builder in this app appends '/api/...'
// itself, e.g. `${environment.apiUrl}/api/case-categories` and `OpenAPI.BASE = environment.apiUrl`,
// so apiUrl must be the bare origin or requests double up to '/api/api/...' and 404), and Caddy on
// that origin reverse-proxies `/api/*` to the esa-api container instead of the shared DEV Azure App
// Service backend that environment.staging.ts points at.
//
// NOTE: the app registration (clientId below) must have this deployment's origin
// (https://esaamlg-stg.akryldev.de) listed under Redirect URIs in Azure AD, otherwise
// login will fail with an AADSTS redirect URI mismatch error.

export const environment = {
  production: false,
  appVersion: require('../../package.json').version,
  name: 'hetzner-staging',
  apiUrl: 'https://esaamlg-stg.akryldev.de',
  clientId: 'a1d6d263-e858-4007-ac32-4784544ec7ed',
  authority: 'https://sts.windows.net/37c571d1-4c26-4395-b365-ac332db93ab6',
  redirectUri: '/',
  postLogoutRedirectUri: '/',
  scopes: ['00000003-0000-0000-c000-000000000000/openid', 'offline_access'],
  supportEmailAddress: 'support@esaamlg.org',
  useMockAuth: false,
  localUserEmail: ''
};
